import { useState } from "react";
import { X } from "lucide-react";
import { BUSINESS } from "../lib/business";

const PRIVACY_TEXT = `Bu Gizlilik Politikası, ${BUSINESS.name} ("biz") tarafından işletilen web sitesini ziyaret eden ve hizmetlerimizden yararlanan kişilerin ("siz") kişisel verilerinin işlenmesine ilişkin esasları açıklamaktadır.

Toplanan Veriler
Sitemiz üzerinden bizimle iletişime geçtiğinizde adınız, telefon numaranız ve adres bilgileriniz yalnızca hizmet sunumu amacıyla kayıt altına alınabilir. Sitemiz çerez veya analitik araçlarla anonim kullanım istatistikleri toplayabilir.

Verilerin Kullanım Amacı
Bilgileriniz; tesisatçı talebinizin karşılanması, randevu organizasyonu, hizmet kalitesinin iyileştirilmesi ve yasal yükümlülüklerin yerine getirilmesi amacıyla kullanılır. Üçüncü taraflarla pazarlama amacıyla paylaşılmaz.

KVKK Haklarınız
6698 Sayılı Kişisel Verilerin Korunması Kanunu kapsamında verilerinize erişme, düzeltme, silme ve işlenmesine itiraz etme haklarına sahipsiniz. Talepleriniz için 0505 495 01 78 numarasından bizimle iletişime geçebilirsiniz.

Veri Güvenliği
Bilgileriniz makul teknik ve idari önlemlerle korunur ve sadece yasal süre boyunca saklanır.`;

const TERMS_TEXT = `Hizmet Şartları
${BUSINESS.name} olarak Kayseri ve ilçelerinde su tesisatçısı hizmeti veriyoruz. Sitede yer alan bilgiler tanıtım amaçlıdır ve genel niteliktedir. Her iş için detaylı keşif sonrası kesin fiyat verilir.

Sorumluluk
Yapılan işlere işçilik garantisi sağlanır. Müşterinin sağladığı arızalı/kalitesiz malzeme nedeniyle oluşan sorunlardan firmamız sorumlu tutulamaz. Acil çağrılarda öncelik sırası vakaların aciliyetine göre belirlenir.

İptal ve Değişiklik
Randevu iptal veya değişiklik talepleriniz için lütfen randevu saatinden önce 0505 495 01 78 numarasını arayın.`;

export const LegalLink = ({ kind, children, ...rest }) => {
    const [open, setOpen] = useState(false);
    const title = kind === "privacy" ? "Gizlilik Politikası / KVKK" : "Hizmet Şartları";
    const text = kind === "privacy" ? PRIVACY_TEXT : TERMS_TEXT;
    return (
        <>
            <button
                {...rest}
                onClick={() => setOpen(true)}
                data-testid={`legal-link-${kind}`}
                className="underline-offset-2 hover:underline hover:text-white transition-colors"
            >
                {children}
            </button>
            {open && (
                <div
                    role="dialog"
                    aria-modal="true"
                    data-testid={`legal-modal-${kind}`}
                    className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm"
                    onClick={() => setOpen(false)}
                >
                    <div
                        className="relative max-w-2xl w-full max-h-[80vh] overflow-y-auto rounded-2xl bg-white p-6 sm:p-8 shadow-2xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={() => setOpen(false)}
                            data-testid={`legal-close-${kind}`}
                            className="absolute top-4 right-4 w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors"
                            aria-label="Kapat"
                        >
                            <X className="w-4 h-4 text-slate-700" strokeWidth={2.5} />
                        </button>
                        <h3 className="font-black tracking-tight text-slate-900 text-2xl">
                            {title}
                        </h3>
                        <pre className="mt-4 whitespace-pre-wrap font-[inherit] text-[14px] leading-relaxed text-slate-700">
                            {text}
                        </pre>
                    </div>
                </div>
            )}
        </>
    );
};
